import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import ActiveStudentsComp from './ActiveStudentsComp'

function ActiveStudents() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <ActiveStudentsComp/>      
        </div>
    </div>
  )
}

export default ActiveStudents